import {DashboardLayout} from '@/modules/layout/ components/dashboard-layout'
import {OrganisationForm} from '@/modules/organisations/components'
import {PageHeader} from '@/shared/components/ui/page-header'
import {Box} from '@chakra-ui/react'
import {LinkButton} from '@cypro/ui/components'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {LuArrowLeft} from 'react-icons/lu'

export const Route = createFileRoute('/organisations/new')({
  component: NewOrganisationPage,
})

function NewOrganisationPage() {
  const {t} = useTranslate('new-organisation')

  return (
    <DashboardLayout hideHeader>
      <Box py="20" maxWidth="50rem" mx="auto">
        <Box py="4">
          <LinkButton to="/organisations" size="sm" variant="plain" colorPalette="cyan" px="0">
            <LuArrowLeft size={16} />
            {t('back_to_organisations')}
          </LinkButton>
        </Box>

        <PageHeader title={t('page_title')} description={t('page_desc')} mb="4" />

        <OrganisationForm />
      </Box>
    </DashboardLayout>
  )
}
